import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    padding: .5rem;
    background: linear-gradient(103.6deg, #FCC046 -13.96%, #CC2A55 58.95%, #BF1827 134.95%);
    border-radius: 10px;
    width: 100%;
    max-width: 90rem;

    > div {
        display: flex;
        width: 100%;
        height: 22rem;
        background: #fff;

        .images {
            width: 44%;
            max-height: 100%;
        }

        .info {
            padding: 1.5rem 3rem 0;
            width: calc(56% - 6rem);
            position: relative;
            display: flex;
            flex-direction: column;
            gap: 2rem;

            ul {
                padding: 0;
                list-style-position: inside;
                font-size: 1.4rem;
            }

            Button {
                max-height: 25%;
                height: 5rem;
                width: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                border-radius: 0;
                font-size: 1.8rem;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 1rem;

                :hover {
                    transform: none;
                    opacity: .9;
                }
            }
        }
    } 

`